import { INITIATOR_VISIBLE_TYPES } from '@picsio/db/src/collections/notificationCenterEvents/constants';

import idsEqual from './idsEqual';

export { INITIATOR_VISIBLE_TYPES };

export default function isOwnNotificationHidden(event, userId) {
  if (!event || !event.initiator || event.initiator._id == null || userId == null) {
    return false;
  }
  if (!idsEqual(event.initiator._id, userId)) {
    return false;
  }
  return !INITIATOR_VISIBLE_TYPES.includes(event.type);
}
